module.exports = __webpack_public_path__ + "static/media/isb-brand.2ef2690b.jpg";